export default __webpack_public_path__ + "static/media/osrcg07_2.f45a416a.png";